import { Params } from "@angular/router";

export class DocumentaleDeeplinkVO {
  url: string;
  params: Object;
}
